"use client"

import { zIndex } from "@nova/constants"
import { ReactNode, useEffect, useState } from "react"
import { createPortal } from "react-dom"

const elementId = "portalled-context-menu-root"

export function PortalledContextMenuRoot() {
    return <div id={elementId} />
}

export function PortalledContextMenu({
    children,
    position,
}: {
    children: ReactNode
    position: { x: number; y: number }
}) {
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    if (!mounted) return null

    const root = document.getElementById(elementId)
    if (!root) return null

    return createPortal(
        <div
            style={{
                position: "fixed",
                left: position.x,
                top: position.y,
                zIndex: zIndex.PortalledTooltip - 50,
            }}
        >
            {children}
        </div>,
        root
    )
}
